import { render, staticRenderFns } from "./bottomadvert.vue?vue&type=template&id=fdfb1ff4&scoped=true&"
import script from "./bottomadvert.vue?vue&type=script&lang=js&"
export * from "./bottomadvert.vue?vue&type=script&lang=js&"
import style0 from "./bottomadvert.vue?vue&type=style&index=0&id=fdfb1ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb1ff4",
  null
  
)

export default component.exports